import axios from "axios";
import { useQuery } from "react-query";
import { API_ENDPOINT, APP_ID } from "../utils/constants";
import { getDbHeader } from "../utils/util";

const useGetEventSettings = () => {
  return useQuery({
    queryKey: ["get-event-settings", APP_ID],
    queryFn: async () => {
      const response = await axios.get(
        `${API_ENDPOINT}event/get-event-settings`,
        getDbHeader(APP_ID)
      );
      return response.data;
    },
    retry: (failureCount, error) => {
      if (!error.response) return true; // Retry on network errors
      const status = error.response.status;
      return status !== 401 && status !== 404 && status !== 500; // No retries for 404/500
    },
  });
};

export default useGetEventSettings;
